<template>
  <div class="container" id="goods-edit">
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <el-form ref="form" label-width="110px" class="info-form" style="margin-top: 22px" :model="form">
        <el-form-item label="用户头像" prop="avatar">
          <img :src="form.userAvatar ? form.userAvatar : require('../../../assets/icon_touxiang_106@2x.png')"
            style="width: 128px; height: 128px" />
        </el-form-item>
        <el-form-item label="用户信息" prop="name">
          <div style="line-height: 30px; margin-top: 4px">
            姓名：{{ form.userName }}
          </div>
          <div style="line-height: 30px">ID：{{ form.userId || "--" }}</div>
          <div style="line-height: 30px">
            电话：{{ form.userPhone || "--" }}
          </div>
        </el-form-item>
        <el-form-item label="下单时间" prop="name">
          {{ form.orderTime || '--' }}
        </el-form-item>
        <el-form-item label="订单编号" prop="name">
          {{ form.orderNo || '--' }}
        </el-form-item>
        <el-form-item label="商品名称" prop="goods">
          {{ form.goodsName }}
        </el-form-item>
        <el-form-item label="商品规格" prop="sku" v-if="form.goodsSkuName">
          {{ form.goodsSkuName }}
        </el-form-item>
        <el-form-item label="商品规格" prop="sku" v-else>
          礼包套餐一
        </el-form-item>
        <el-form-item label="评论星数" prop="star">
          {{ form.starLabel }}
        </el-form-item>
        <el-form-item label="评论内容" prop="content">
          <div style="width:50%;">
            {{ form.content }}
          </div>

        </el-form-item>
        <el-form-item label="评论图片">
          <div style="display: flex; margin-top: 12px">
            <div class="itemI" style="margin-left: 8px" v-for="(item, index) in form.imgList" :key="item + index">
              <el-image @click="look(item)" style="width: 108px; height: 108px; border-radius: 6px"
                :src="item"></el-image>
            </div>
          </div>
          <!-- <div class="messageI">
            图片尺寸：建议上传大小不得超过2M,支持jpg、jpeg、png格式
          </div> -->
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <span v-if="form.showFlag == true">显示</span>
          <span v-if="form.showFlag == false">隐藏</span>
        </el-form-item>
      </el-form>
      <div style="height: 20px"></div>
    </div>
    <div class="back-btn">
      <el-button type="info" @click="back">返回</el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" fit="contain" :src="dialogImageUrl" alt="" style="width: 100%" />
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import uploadPicture from '@/components/upload/mallPicture.vue'
import uploadPicture1 from '@/components/upload/dragpicturew.vue'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    uploadPicture,
    uploadPicture1
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      goodsName: '',
      fileList: [
        {
          url: 'https://fenxiao.muruji.com/b4908f91ff7c4c75bb4bfd3f920709cc/6cdbbf91-4e0e-46c1-84c2-d03736b13e6b'
        }
      ],
      goodsList: [
        {
          name: "测试商品",
          image: 'https://fenxiao.muruji.com/internalSystem/b2c83e66-2699-407d-bad4-c591e20827a0'
        },
        {
          name: "测试商品",
          image: 'https://fenxiao.muruji.com/internalSystem/b2c83e66-2699-407d-bad4-c591e20827a0'
        },
        {
          name: "测试商品",
          image: 'https://fenxiao.muruji.com/internalSystem/b2c83e66-2699-407d-bad4-c591e20827a0'
        },
        {
          name: "测试商品",
          image: 'https://fenxiao.muruji.com/internalSystem/b2c83e66-2699-407d-bad4-c591e20827a0'
        },

      ],
      dialogGoods: false,
      radio: '1',
      startTime: [],
      expireDates: [
        {
          dictId: 1,
          dictName: '一个月'
        },
        {
          dictId: 3,
          dictName: '三个月'
        },
        {
          dictId: 12,
          dictName: '一年'
        },
        {
          dictId: 0,
          dictName: '永久'
        },
      ],
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '商品评论', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '查看评论', path: '', type: '0' }
        ]
      },
      checked1: true,
      checked2: false,
      radio: 3,
      name: '---',
      dialogUser: false,
      currentPage4: 1,
      tableData: [

      ],
      tableDataF: [

      ],
      detail: {},
      form: {
        userAvatar: '',
        userName: '',
        psGoodsId: '',
        psGoodsSku: '',
        imgList: [],
        star: '',
        content: '',
        showFlag: '',
        submitTime: '',
        psGoodsName: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入用户昵称', trigger: 'blur' },
        ],
        commentTime: [
          { required: true, message: '请选择评论时间', trigger: 'change' },
        ],
        avatar: [
          { required: true, message: '请上传用户头像', trigger: 'change' },
        ],
        goods: [
          { required: true, message: '请选择商品', trigger: 'change' },
        ],
        sku: [
          { required: true, message: '请选择商品规格', trigger: 'change' },
        ],
        star: [
          { required: true, message: '请选择星数', trigger: 'change' },
        ],
        content: [
          { required: true, message: '请输入评论内容', trigger: 'blur' },
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' },
        ],
      },
      arr: []
    }
  },
  created() {
    if (this.$route.query.id) {
      this.getDetail()
    }

  },

  methods: {
    look(src) {
      this.dialogVisible = true
      this.dialogImageUrl = src
    },
    selectGoods() {
      console.log(88888888)
      this.dialogGoods = true
    },
    getImage(val) {

    },
    back() {
      this.$router.go(-1)
    },
    select() {
      console.log(this.arr)
    },
    getDetail() {
      this.axios.get('/goodsEvaluation/get?id=' + this.$route.query.id)
        .then(res => {
          if (res.code == 0) {
            this.form = res.data

          }
        })
    },
    handleCurrentChange() {

    },
    handleSizeChange() {

    },
    handleSelectionChange() {

    }
  }
}
</script>
<style scoped lang="scss">
.messageI {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  // margin-top: 7px;
  color: #909099;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.search-box {
  width: 100%;
  height: 50px;
  background: #f8f8f8;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 1px solid #e8eaec;
  border-bottom: 0;
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #ebeefa;
  border-color: #c0c0cc;
  color: #c0c4cc;
  cursor: not-allowed;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: left !important;
}

.detail {
  width: 378px;
  min-height: 82px;
  background: #ebeefa;
  opacity: 1;
  border-radius: 3px;
  padding: 10px 10px;
  line-height: 30px;
  color: #303033;
}

.s-label {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #303033;
  opacity: 1;
}

.start {
  width: 10px;
  height: 10px;
  background: #13ce4b;
  border-radius: 50%;
  opacity: 1;
  margin-top: 15px;
  margin-right: 5px;
}

.end {
  width: 10px;
  height: 10px;
  background: #f63c56;
  border-radius: 50%;
  opacity: 1;
  margin-top: 15px;
  margin-right: 5px;
}

.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}

.back-btn {
  width: 30%;
  text-align: left;
  padding-bottom: 20px;

  .el-button {
    width: 184px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }
}
</style>

